import { defineTheme } from '../utils'

export const sky = defineTheme({
  menuTitleBlock: {
    title: 'bg-black p-4 text-center text-4xl text-white md:text-6xl',
  },
  themeLogo: {
    image: 'hidden',
  },
  menuItem: {
    dinner: {
      base: 'mb-3 grid grid-cols-[1fr_auto] items-start gap-1',
      title: 'font-[Agenda] font-bold uppercase',
      description: 'order-2 col-span-2',
      priceList: 'text-right',
      priceItem: 'inline font-bold',
      icons: 'order-4 col-span-2 gap-2',
      label: 'order-3 col-span-2 bg-black text-center text-white',
    },
    drinks: {
      base: 'grid grid-cols-[1fr_auto] items-start gap-1',
      title: 'font-[Agenda] font-bold uppercase',
      description: 'order-2 col-span-2 text-sm',
      priceList: 'text-right text-tertiary',
      priceItem: 'font-bold',
      icons: 'order-4 col-span-2 gap-2',
      label: 'order-3 col-span-2 mb-1 bg-black p-2 font-base text-sm font-medium text-white',
    },
  },
  menuCategory: {
    title: 'text-3xl uppercase',
  },
  menuSubCategory: {
    title: 'mb-3 text-lg font-bold uppercase underline',
  },
  languageButton: {
    base: 'rounded border px-4 py-3 hover:opacity-70',
  },
  page: {
    heading: 'font-[Agenda] text-7xl uppercase',
    container: 'after:fixed after:inset-0 after:-z-10 after:bg-[url(/images/sky_bg.jpg)] after:bg-cover after:bg-center max-xl:after:hidden',
    menuSection: 'after:fixed after:inset-0 after:-z-10 after:bg-[url(/images/sky_bg.jpg)] after:bg-cover after:bg-center max-xl:after:hidden',
  },
  filterBar: {
    bar: 'bg-black text-white',
    checkbox: ' accent-white',
    closeButton: 'bg-white text-black hover:bg-white/80',
    masterItem: 'text-black',
    itemLabel: 'text-black',
    popoverTitle: 'text-white',
    popover: 'bg-white',
    popoverHeader: 'bg-black',
  },
})
